import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern Living kit — a countertop microwave, 0.5 x 0.35 x 0.3 m. Authored at
// floor level like every kit piece; the builder sets it on a 0.9 m worktop.
const BODY = "#2e2e30";
const DARK_GLASS = "#3a3f44";
const PANEL = "#4a4e52";
const STEEL = "#aab2b8";

export const microwave = defineModel({
  id: "microwave",
  batchId: "modern",
  name: "Microwave",
  tags: ["modern", "interior", "appliance", "kitchen", "microwave", "countertop"],
  summary: "A black countertop microwave with a dark glass door and side button panel.",
  tiles: { w: 1, h: 1 },
  footprint: 0.6,
  parts(): Part[] {
    return [
      // body
      { geometry: new THREE.BoxGeometry(0.5, 0.3, 0.33), color: BODY, position: [0, 0.15, -0.01] },
      // dark glass door (left of the panel)
      { geometry: new THREE.BoxGeometry(0.32, 0.22, 0.02), color: DARK_GLASS, position: [-0.06, 0.15, 0.16] },
      // thin door handle
      { geometry: new THREE.BoxGeometry(0.02, 0.22, 0.02), color: STEEL, position: [0.115, 0.15, 0.175] },
      // button panel on the right
      { geometry: new THREE.BoxGeometry(0.12, 0.24, 0.015), color: PANEL, position: [0.18, 0.15, 0.16] },
      // buttons
      { geometry: new THREE.BoxGeometry(0.07, 0.03, 0.01), color: STEEL, position: [0.18, 0.22, 0.17] },
      { geometry: new THREE.BoxGeometry(0.07, 0.03, 0.01), color: STEEL, position: [0.18, 0.16, 0.17] },
      { geometry: new THREE.BoxGeometry(0.07, 0.05, 0.01), color: BODY, position: [0.18, 0.08, 0.17] },
    ];
  },
  animations: [],
});
